// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16RRK","title":"styles_title__o_iL5"};